import { useState } from "react";
import { getAllUserInfo } from "@api/getUserInfo";

/**
 * 사용자 정보를 관리하는 훅
 * @returns {object} 사용자 정보 관련 상태와 함수
 */
const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState({});

  const getUserInfo = async () => {
    try {
      const res = await getAllUserInfo();

      if (res.Code === "0000") {
        setUserInfo(res?.Data);
        return res?.Data;
      } else {
        setUserInfo({});
        return null;
      }
    } catch (error) {
      console.error("Error in getUserInfo:", error);
      setUserInfo({});
      return null;
    }
  };

  return { userInfo, setUserInfo, getUserInfo };
};

export default useUserInfo;
